// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s7A8","controls":"styles_controls__3uxkY","charLimit":"styles_charLimit__2cfvD","input":"styles_input__3c4Kt","send":"styles_send__3srUp"};